// @flow
import React, { Component } from 'react'
// import decode from 'jwt-decode'
import { auth0Domain } from 'client/config'
import { withRouter } from '../with-router'
import axios from 'axios'
import * as url from 'url'
import { partition } from 'lodash'
import { isTokenExpired } from 'client/utils/jwt.js'

import Organization from './organization'

type OrganizationType = {
  avatar_url: string,
  name: string,
  organization_name: string,
}

// $FlowFixMe 
class Organizations extends Component {
  props: {
    location: {
      query: {
        state: string,
        token: string
      }
    }
  }

  // state: {
  //   organization: OrganizationType
  // }

  static displayName = 'Organization'

  state: any = {
    organization: {},
    orgWithSSOlogin: [],
    orgWithoutSSOlogin: [],
    isDataFetched: false
  }

  componentDidMount () {// $FlowFixMe
    const token = this.props.searchParams.get('token')
    if (isTokenExpired(token)) {// $FlowFixMe
      this.props.navigate('/', { replace: true })
    }
    this.getOrganizations()
  }

  async getOrganizations () {
    const siteUrl = window.location.href
    const parsedUrl = url.parse(siteUrl, true)
    if (parsedUrl.pathname) {
      const pathName = parsedUrl.pathname.substring(1)
      let slugName = pathName.slice(0, pathName.indexOf('/'))
      if (parsedUrl.query) {
        const token = parsedUrl.query.token
        slugName = slugName !== '' ? slugName : 'undefined'
        const { data: { orgWithSSOlogin, orgWithoutSSOlogin } } = await axios.get(`/api/v1/verify-SSO/${slugName}`, { headers: { token } })
        if (orgWithoutSSOlogin && orgWithoutSSOlogin.length === 0) {
          const [mobileSlug, slug] = partition(orgWithSSOlogin[0].slugs, s => s.includes('mobile'))
          const mobile = parsedUrl.query ? parsedUrl.query.mobile : ''
          const ssoUrl = mobile ? mobileSlug[0] : slug[0]
          const orgNames = orgWithSSOlogin.map(function (val) {
            return val.organization_name
          }).join(',')
          window.location.replace('/sso-org-error?org=' + encodeURIComponent(orgNames) + '&ssolink=' + encodeURIComponent(ssoUrl))
        } else {// $FlowFixMe
          this.setState({ orgWithSSOlogin, orgWithoutSSOlogin, isDataFetched: true })
        }
      }
    }
  }
  // $FlowFixMe
  onSelectOrganization (organization: OrganizationType, event: SyntheticEvent) {
    event.preventDefault()// $FlowFixMe
    this.setState({ organization }, () => this.refs.form.submit())
  }

  render (): any {
    console.log('CONTAINS MULTIPLE ORGS', this.props.location)// $FlowFixMe
    const token = this.props.searchParams.get('token')// $FlowFixMe
    const state = this.props.searchParams.get('state')
    console.log(token, state, 'searchParams')
    // const {
    //   location: {
    //     query: { token, state }
    //   }
    // } = this.props
    // const { app_metadata: { organizations } } = decode(token)
    const { organization, orgWithSSOlogin, orgWithoutSSOlogin, isDataFetched } = this.state
    return isDataFetched
      ? <div className='login'>
        <div className='login__header'>
          <i className='icon icon--logo' />
          <h3>Select an organization</h3>
        </div>
        <form action={`https://${auth0Domain}/continue?state=${state}`} method='POST' ref='form'>
          <input type='hidden' name='token' value={token} />
          <input type='hidden' name='user_id' value={organization.id} />
          <input type='hidden' name='organization_id' value={organization.organization_id} />
          {orgWithSSOlogin.length > 0
            ? (
              <div>
                <ul className='organizations'>
                  {// $FlowFixMe
                    orgWithoutSSOlogin.map((org) => <Organization organization={org} onSelect={this.onSelectOrganization.bind(this, org)} key={org.id} />)
                  }
                </ul>
                <div className='login__header'>
                  <h3>Direct login is not allowed for the following organizations.</h3>
                </div>
                <ul className='organizations'>
                  {// $FlowFixMe
                    orgWithSSOlogin.map((org) => <Organization organization={org} onSelect={this.onSelectOrganization.bind(this, org)} key={org.id} disabled />)
                  }
                </ul>
              </div>
            )
            : (
              <ul className='organizations'>
                {// $FlowFixMe
                  orgWithoutSSOlogin.map((org) => <Organization organization={org} onSelect={this.onSelectOrganization.bind(this, org)} key={org.id} />)
                }
              </ul>
            )}
        </form>
      </div>
      : null
  }
}

export default (withRouter(Organizations): any)
